import React, { useEffect, useMemo } from "react";
import { ScrollView, StyleSheet, View } from "react-native";
import { useTheme, Paragraph, Button, HelperText } from "react-native-paper";
import { Block } from "@block";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { StackActions, useNavigation } from "@react-navigation/native";
import { QueueSpacing, StackSpacing } from "@components/spacing";
import { TextInput } from "react-native-paper";
import { spacing } from "@styles/spacing";
import { useDesktopMediaQuery } from "@media-query";
import ScreenNameType from "@navigation/nav-screens";
import { useDispatch, useSelector } from "react-redux";
import { getTransferCharityResponseCreatedSelector, getTransferCharityStoreSelector } from "../reducer/selectors";
import { ConvertCurrencyToVietnamese, formatNumberThousand } from "app/shared/util/format-currency";
import { fetchTransferCharityConfirmRequest, setTransferCharityStore } from "../reducer/actions";
import { useTranslation } from "react-i18next";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import { StepProcessUniversal } from "app/shared/components/stepper-process/stepper-process";
import { testProps } from "app/shared/util/test-props";
import { TextInputMultiline } from "app/shared/components/form/input";
import { RECEIVING_UNIT } from "../transfer-charity-create/form-trans-charity/form-trans-charity";
import { getContactIdSelector } from "app/modules/account-management/reducer/selectors";
import { pushCleverTapEvent } from "app/shared/util/app-flyer";
import { Constant } from "app/shared/constant/constant";

const TransferCharityConfirm = () => {
  const { colors, fonts } = useTheme();
  const { dispatch, goBack } = useNavigation();
  const { t } = useTranslation();
  const dispatchStore = useDispatch();
  const isDesktop = useDesktopMediaQuery();
  const convertCurrencyToVietnamese = new ConvertCurrencyToVietnamese();

  const transferCharityStore = useSelector(getTransferCharityStoreSelector);
  const responseCreate = useSelector(getTransferCharityResponseCreatedSelector);
  const contactId = useSelector(getContactIdSelector);

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => {
        eventPushCleverTap(undefined, undefined, "cancel");
        dispatch(StackActions.replace(ScreenNameType.HOME));
      },
    },
    {
      name: t("TRANFER_CHUYEN_TIEN"),
      onPressSubtitle: () => {
        eventPushCleverTap(undefined, undefined, "cancel");
        dispatch(StackActions.replace(ScreenNameType.LIST_TRANSFER));
      },
    },
    {
      name: t("TRANFER_CHUYEN_TIEN_TU_THIEN"),
      onPressSubtitle: () => {},
    },
  ];

  const textInputProps: object = {
    theme: { colors: { primary: colors.accent, text: colors.accent } },
    outlineColor: "transparent",
    editable: false,
  };

  const styles = useMemo(
    () =>
      StyleSheet.create({
        textInput: { color: colors.accent, backgroundColor: colors.backgroundForm, fontWeight: "700", textShadowColor: "black" },
        textInputAmount: { fontSize: 18 },
        buttonForm: { width: 128, alignSelf: "center", backgroundColor: colors.backgroundForm },
        desktopDisplay: { display: isDesktop ? "flex" : "none" },
        fieldFormStyles: { color: colors.text, width: 200, fontWeight: "700", fontSize: 16 },
      }),
    [colors.accent, colors.backgroundForm, colors.text, isDesktop],
  );

  const onPressCancel = () => {
    eventPushCleverTap(undefined, undefined, "cancel");
    dispatchStore(setTransferCharityStore({ ...transferCharityStore, isCreated: false, responseCreate: undefined }));
    goBack();
  };

  const onPressAccept = () => {
    dispatchStore(fetchTransferCharityConfirmRequest(responseCreate));
  };

  const eventPushCleverTap = (status?: boolean, response?: string, action?: string) => {
    const { eventNameCT, paramsCT } = handlerParamsCleverTap(status, response, action);
    pushCleverTapEvent(eventNameCT, paramsCT);
  };

  const handlerParamsCleverTap = (status?: boolean, response?: string, action?: string) => {
    console.log("handlerParamsCleverTap");
    let param = {};
    param = {
      ct_channel: "ib_rb",
      ct_cccd_ID: contactId,
      ct_transfer_type: "transfer_charity",
      ct_account_type: transferCharityStore.dataCreate?.TYPE === Constant.TRANSFER.TRANSFER_247_TYPE.CRD ? "ATM card number" : "Account number", // Account number | ATM card number
      ct_beneficiary_bank: transferCharityStore.dataCreate?.BANK?.value,
      ct_transfer_amount: transferCharityStore.dataCreate?.AMOUNT,
      ct_transfer_content: transferCharityStore.dataCreate?.DESCRIPTION,
      ct_transfer_fee: responseCreate?.TRANSFER?.TOTAL_FEE_AMOUNT,
      ct_transfer_charged: transferCharityStore.dataCreate?.FEE_TYPE === Constant.TRANSFER.TRANSFER_FEE_TYPE.I ? "receiver" : "transferor", // receiver | transferor
      ct_button: action || "", // account_detail |fee_detail | beneficiary | continue | cancel
      ct_error_message: status === false ? response || "" : "",
    };
    if (status !== undefined) {
      param = {
        ...param,
        ct_transfer_confirm_status: status ? "success" : "failure",
      };
    }
    return {
      eventNameCT: "ct_transfer_confirm",
      paramsCT: param,
    };
  };

  const FieldForm = ({ name = "" }) => (
    <View style={styles.desktopDisplay}>
      <StackSpacing size="medium" />
      <Paragraph style={styles.fieldFormStyles}>{name}</Paragraph>
      <StackSpacing size="medium" />
    </View>
  );

  const FormAccountHolder = (
    <Block ph={isDesktop ? spacing.galactic : spacing.large} row={isDesktop ? true : false} pt={spacing.medium}>
      <FieldForm name={t("TRANFER_TAI_KHOAN_NGUON")} />
      <Block flex={1} bg={colors.backgroundForm} br={12} p={spacing.large}>
        <TextInput
        autoCompleteType={undefined} {...textInputProps}
        style={styles.textInput}
        label={t("TRANFER_TAI_KHOAN_NGUON")}
        value={transferCharityStore.dataCreate?.ACCOUNT_DEBIT?.ACCOUNTNO}        />
        <TextInput
        autoCompleteType={undefined} {...textInputProps}
        style={styles.textInput}
        label={t("ACC_SO_DU_KHA_DUNG")}
        value={formatNumberThousand(transferCharityStore.dataCreate?.ACCOUNT_DEBIT?.AVAILABLEBALANCE)}
        right={<TextInput.Affix textStyle={fonts.regular} text={t("COMMON_VND")} />}        />
      </Block>
    </Block>
  );

  const FormTransfer = (
    <Block ph={isDesktop ? spacing.galactic : spacing.large} row={isDesktop ? true : false} pt={spacing.large}>
      <FieldForm name={t("TRANFER_TAI_KHOAN_NHAN")} />
      <Block flex={1} bg={colors.backgroundForm} br={12} p={spacing.large}>
        <Block spaced row={isDesktop ? true : false}>
          <Block flex={1}>
            <TextInput
            autoCompleteType={undefined} {...textInputProps}
            style={styles.textInput}
            label={t("TRANFER_CHARITY_DON_VI_TIEP_NHAN")}
            value={RECEIVING_UNIT.RECEIVING_NAME}            />
          </Block>
          <QueueSpacing size="huge" />
          <Block flex={1}>
            <TextInput
            autoCompleteType={undefined} {...textInputProps}
            style={styles.textInput}
            label={t("TRANFER_TAI_KHOAN_NHAN")}
            value={responseCreate?.TRANSFER?.CREDIT_ACCOUNT_NUMBER}            />
          </Block>
        </Block>
        <TextInputMultiline
          name="TRANFER_TEN_TAI_KHOAN"
          {...textInputProps}
          style={styles.textInput}
          label={t("TRANFER_TEN_TAI_KHOAN")}
          value={responseCreate?.TRANSFER?.CREDIT_ACCOUNT_NAME}
        />
        <TextInputMultiline
          name="TRANFER_TAI_NGAN_HANG"
          {...textInputProps}
          style={styles.textInput}
          label={t("TRANFER_TAI_NGAN_HANG")}
          value={RECEIVING_UNIT.BANK_NAME}
        />
        <Block spaced row={isDesktop ? true : false}>
          {transferCharityStore.dataCreate?.CHARITY?.FULL_NAME?.length ? (
            <Block flex={1}>
              <TextInput
              autoCompleteType={undefined} {...textInputProps}
              style={styles.textInput}
              label={t("TRANFER_CHARITY_TEN_NGUOI_UNG_HO")}
              value={transferCharityStore.dataCreate?.CHARITY?.FULL_NAME}              />
            </Block>
          ) : (
            <></>
          )}
          <QueueSpacing size="huge" />
          {transferCharityStore.dataCreate?.CHARITY?.PHONE_NUM?.length ? (
            <Block flex={1}>
              <TextInput
              autoCompleteType={undefined} {...textInputProps}
              style={styles.textInput}
              label={t("TRANFER_CHARITY_SO_DIEN_THOAI")}
              value={transferCharityStore.dataCreate?.CHARITY?.PHONE_NUM}              />
            </Block>
          ) : (
            <></>
          )}
        </Block>
        {transferCharityStore.dataCreate?.CHARITY?.ADDRESS?.length ? (
          <TextInputMultiline
            name="TRANFER_CHARITY_DIA_CHI"
            {...textInputProps}
            style={styles.textInput}
            label={t("TRANFER_CHARITY_DIA_CHI")}
            value={transferCharityStore.dataCreate?.CHARITY?.ADDRESS}
          />
        ) : (
          <></>
        )}
        <TextInputMultiline
          name="TRANFER_CHARITY_HOAN_CANH_UNG_HO"
          {...textInputProps}
          style={styles.textInput}
          label={t("TRANFER_CHARITY_HOAN_CANH_UNG_HO")}
          value={transferCharityStore.dataCreate?.CHARITY?.DONATION_CASE}
        />
        <TextInput
        autoCompleteType={undefined} {...textInputProps}
        style={[styles.textInput, styles.textInputAmount]}
        label={t("TRANFER_SO_TIEN")}
        value={formatNumberThousand(responseCreate?.TRANSFER?.DEBIT_AMOUNT)}
        right={<TextInput.Affix textStyle={fonts.regular} text={t("COMMON_VND")} />}        />
        <HelperText type="info" visible={true} style={{ color: colors.accent }}>
          {convertCurrencyToVietnamese.convert(Number(responseCreate?.TRANSFER?.DEBIT_AMOUNT || 0))}
        </HelperText>
        <Block row={isDesktop ? true : false} flex={1}>
          <Block flex={isDesktop ? 1 : undefined}>
            <TextInput
            autoCompleteType={undefined} {...textInputProps}
            style={styles.textInput}
            label={t("TRANFER_BEN_CHIU_PHI")}
            value={responseCreate?.TRANSFER?.FEE_TYPE === "I" ? t("TRANFER_BEN_NHAN") : t("TRANFER_BEN_CHUYEN")}            />
          </Block>
          <QueueSpacing size="huge" />
          <Block flex={isDesktop ? 1 : undefined}>
            <TextInput
            autoCompleteType={undefined} {...textInputProps}
            style={styles.textInput}
            label={t("FEE_TONG_PHI")}
            value={formatNumberThousand(responseCreate?.TRANSFER?.TOTAL_FEE_AMOUNT)}
            right={<TextInput.Affix textStyle={fonts.regular} text={t("COMMON_VND")} />}            />
          </Block>
        </Block>
      </Block>
    </Block>
  );

  const ButtonRow = (
    <Block row middle pv={spacing.huge}>
      <Block w={isDesktop ? 200 : 0} />
      <Button mode="contained" style={styles.buttonForm} onPress={onPressCancel}>
        {t("COMMON_QUAY_LAI")}
      </Button>
      <QueueSpacing size="large" />
      <Button onPress={onPressAccept} mode="contained" {...testProps("nextConfirmBtn")}>
        {t("COMMON_TIEP_TUC")}
      </Button>
    </Block>
  );

  React.useEffect(() => {
    if (transferCharityStore.statusConfirm === "error") {
      eventPushCleverTap(false, "failure" + (transferCharityStore.errorMsg || ""), "continue");
    } else if (transferCharityStore.statusConfirm === "ok") {
      eventPushCleverTap(true, "success" + (transferCharityStore.errorMsg || ""), "continue");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transferCharityStore.statusConfirm]);

  useEffect(() => {
    if (transferCharityStore.isConfirm) {
      // Replace screen
      dispatch(StackActions.replace(ScreenNameType.TRANS_CHARITY_AUTH));
    }
  }, [dispatch, transferCharityStore.isConfirm]);

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("TRANFER_CHUYEN_TIEN_TU_THIEN")} subtitles={subtitlesArrays} />
        <StepProcessUniversal currentSteps={1} />
        {FormAccountHolder}
        {FormTransfer}
        {ButtonRow}
      </ScrollView>
    </Block>
  );
};

export default TransferCharityConfirm;
